import { render, staticRenderFns } from "./CreateHelperTag.vue?vue&type=template&id=5ceb5b5a&scoped=true"
import script from "./CreateHelperTag.vue?vue&type=script&lang=js"
export * from "./CreateHelperTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ceb5b5a",
  null
  
)

export default component.exports